import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import CustomAdvanceTable from 'components/common/advance-table/CustomAdvanceTable';
import Flex from 'components/common/Flex';
import dayjs from 'dayjs';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { permissionsKeyMap } from 'routes/permissions/permissionKeys';
import { formatMoney } from 'helpers/utils';
import { useDonorGiftAid } from 'hooks/useDonors';

const DonorGiftAid = () => {
  const { id: donarId } = useParams();
  const { giftAidData } = useDonorGiftAid(donarId);

  const columns = [
    {
      accessor: 'ref_number',
      Header: 'Ref.',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'created_at',
      Header: 'Date',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => (
        <> {dayjs(rowData.row.original.created_at).format('MMM-DD-YYYY')} </>
      )
    },
    {
      accessor: 'started_on',
      Header: 'Started on',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => (
        <> {dayjs(rowData.row.original.started_on).format('MMM-DD-YYYY')} </>
      )
    },
    {
      accessor: 'ended_on',
      Header: 'End on',
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => (
        <> {dayjs(rowData.row.original.ended_on).format('MMM-DD-YYYY')} </>
      )
    },
    {
      accessor: 'eligibility',
      Header: 'Eligibility',
      cellProps: {
        className: 'py-2'
      }
    },
    {
      accessor: 'declared_via',
      Header: 'Declared Via',
      cellProps: {
        className: 'py-2'
      }
    }
    // {
    //   accessor: 'id',
    //   DonationHeader: '',
    //   cellProps: {
    //     className: 'py-2 text-end'
    //   },
    //   disableSortBy: true,

    //   Cell: rowData => {
    //     const { id } = rowData.row;
    //     return (
    //       <TableRowAction
    //         onCLickEdit={() => console.log(id)}
    //         onCLickDelete={() => console.log(id)}
    //       />
    //     );
    //   }
    // }
  ];

  return (
    <>
      <Card className="mb-3">
        <Card.Header className="p-4 pb-0">
          <Card.Title className="fw-medium" style={{ fontSize: '1.25rem' }}>Insights</Card.Title>
        </Card.Header>
        <Card.Body className="p-4">
          <Row>
            <Col md={4} className="pe-4">
              <Flex className={'border-md-end mb-3 mb-md-0'}>
                <FontAwesomeIcon
                  icon={'circle'}
                  className="me-2 text-primary"
                />
                <div className="fw-medium">
                  <p className="mb-2 text-600" style={{ fontSize: '1rem' }}>Eligible For Gift Aid?</p>
                  <p className="fs-2 mb-0 text-900" style={{ fontSize: '1rem' }}>
                    {giftAidData?.eligible
                      ? 'Yes'
                      : 'No'}{' '}
                    <FontAwesomeIcon
                      icon={'check'}
                      className="text-success border p-1 fs-0 rounded-5 border-success"
                    />
                  </p>
                </div>
              </Flex>
            </Col>
            <Col md={4} className="pe-4">
              <Flex className={'border-md-end mb-3 mb-md-0'}>
                <FontAwesomeIcon
                  icon={'circle'}
                  className="me-2 text-warning"
                />
                <div className="fw-medium">
                  <p className="mb-2 text-600" style={{ fontSize: '1rem' }}>Awaiting Submission</p>
                  <p className="fs-2 mb-0 text-900" style={{ fontSize: '1rem' }}>
                    $ {giftAidData?.awaitingSubmission || 0}
                  </p>
                </div>
              </Flex>
            </Col>
            <Col md={4}>
              <Flex>
                <FontAwesomeIcon
                  icon={'circle'}
                  className="me-2 text-warning"
                />
                <div className="fw-medium">
                  <p className="mb-2 text-600" style={{ fontSize: '1rem' }}>Claimed To Date</p>
                  <p className="fs-2 mb-0 text-900" style={{ fontSize: '1rem' }}>{formatMoney(0)}</p>
                </div>
              </Flex>
            </Col>
          </Row>
          <hr />
          <div>
            <p className="fw-medium" style={{ fontSize: '1.25rem' }}>Current Declarations</p>
            <div className="fw-medium">
              <Flex justifyContent={'between'}>
                <p className="text-800" style={{ fontSize: '1rem' }}>Eligible</p>
                <p className="text-800" style={{ fontSize: '1rem' }}>
                  <FontAwesomeIcon
                    icon={'circle'}
                    className={classNames('me-2', {
                      'text-success ':
                        giftAidData?.declarationLog[0]?.eligibility ===
                        'Yes',
                      'text-danger ':
                        giftAidData?.declarationLog[0]?.eligibility ===
                        'No'
                    })}
                  />
                  {giftAidData?.declarationLog[0]?.eligibility}
                </p>
              </Flex>
              <Flex justifyContent={'between'}>
                <p className="text-800" style={{ fontSize: '1rem' }}>Valid From</p>
                <p className="text-800" style={{ fontSize: '1rem' }}>
                  {dayjs(
                    giftAidData?.declarationLog[0]?.started_on
                  ).format('MMM-DD-YYYY')}{' '}
                </p>
              </Flex>
              <Flex justifyContent={'between'}>
                <p className="text-800" style={{ fontSize: '1rem' }}>Declration Date</p>
                <p className="text-800" style={{ fontSize: '1rem' }}>
                  {dayjs(
                    giftAidData?.declarationLog[0]?.created_at
                  ).format('MMM-DD-YYYY')}{' '}
                </p>
              </Flex>
              <Flex justifyContent={'between'}>
                <p className="text-800" style={{ fontSize: '1rem' }}>End Date</p>
                <p className="text-800" style={{ fontSize: '1rem' }}>
                  {' '}
                  {dayjs(
                    giftAidData?.declarationLog[0]?.ended_on
                  ).format('MMM-DD-YYYY')}{' '}
                </p>
              </Flex>
              {/* <Flex justifyContent={'between'}>
                <p className="text-800">Notes</p>
                <FontAwesomeIcon icon={'pen'} className="text-800" />
              </Flex>
              <Flex justifyContent={'between'}>
                <p className="text-800">Attachments</p>
                <FontAwesomeIcon icon={'pen'} className="text-800" />
              </Flex> */}
              <Flex justifyContent={'between'}>
                <p className="text-800 mb-0" style={{ fontSize: '1rem' }}>Status</p>
                <p
                  className={classNames('mb-0', {
                    'text-success': dayjs().isBefore(
                      giftAidData?.declarationLog[0]?.ended_on
                    ),
                    'text-danger': dayjs().isAfter(
                      giftAidData?.declarationLog[0]?.ended_on
                    )
                  })}
                  style={{ fontSize: '1rem' }}
                >
                  {' '}
                  {dayjs().isBefore(
                    giftAidData?.declarationLog[0]?.ended_on
                  )
                    ? 'Active'
                    : 'Not-Active'}{' '}
                </p>
              </Flex>
            </div>
          </div>
        </Card.Body>
      </Card>
      <Row>
        <Col md={12} xxl={12} className="h-md-100">
          {giftAidData?.declarationLog && (
            <CustomAdvanceTable
              data={giftAidData.declarationLog}
              columns={columns}
              title="Declarations log"
              showSearchInput
              searchInputPlaceHolder="Search"
              // addNew
              perPage={50}
              subject={permissionsKeyMap.donor.children.donors}
            />
          )}
        </Col>
      </Row>
    </>
  );
};

export default DonorGiftAid;
